var Alberta = "앨버타";
var Manitoba = "매니토바";
var Nunavut = "누나부트";
var Ontario = "온타리오";
var Quebec = "퀘벡";
var Saskatchewan = "서스캐처원";
var Yukon = "유콘";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "브리티시컬럼비아",
	Manitoba: Manitoba,
	"New Brunswick": "뉴브런즈윅",
	"Newfoundland and Labrador": "뉴펀들랜드 래브라도",
	"Northwest Territories": "노스웨스트 준주",
	"Nova Scotia": "노바스코샤",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "프린스에드워드아일랜드",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
